// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"AddTimeOffModal-module__checkboxContainer___wk3V2","quickAdd":"AddTimeOffModal-module__quickAdd___jwLEP"};